import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const RegulationCard = ({ title, icon, content, color }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 p-6 hover:shadow-elevation-3 transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className={`p-2 bg-muted rounded-md ${color}`}>
            <Icon name={icon} size={24} strokeWidth={2} />
          </div>
          <h3 className="font-heading font-semibold text-foreground">{title}</h3>
        </div>
        
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="p-1 hover:bg-muted rounded transition-smooth md:hidden"
          aria-label={isExpanded ? 'Collapse' : 'Expand'}
        >
          <Icon 
            name={isExpanded ? 'ChevronUp' : 'ChevronDown'} 
            size={20} 
            strokeWidth={2}
            className="text-muted-foreground"
          />
        </button>
      </div>
      
      <div className={`${isExpanded ? 'block' : 'hidden'} md:block`}>
        <p className="font-body text-sm text-muted-foreground leading-relaxed">
          {content}
        </p>
      </div>
    </div>
  );
};

export default RegulationCard;